<template>
    <label class="fontawesome-checkbox" :class="{ 'is-disabled': disabled }">
        <input ref="inputRef" type="checkbox" v-model="internalValue" :disabled="disabled" @click="$emit('click')" />
        <span>
            <slot></slot>
        </span>
    </label>
</template>

<script setup lang="ts">
    import { ref, computed, watch, onMounted } from "vue";

    const props = defineProps<{
        disabled?: boolean;
        modelValue: boolean;
        indeterminate?: boolean;
    }>();

    const emit = defineEmits<{
        "update:modelValue": [boolean];
        change: [boolean];
        click: [];
    }>();

    const inputRef = ref<HTMLInputElement | null>(null);

    const internalValue = computed({
        get: () => props.modelValue,
        set: (value: boolean) => {
            emit("update:modelValue", value);
            emit("change", value);
        },
    });

    function applyIndeterminate() {
        if (inputRef.value) {
            inputRef.value.indeterminate = !!props.indeterminate;
        }
    }

    onMounted(applyIndeterminate);
    watch(() => props.indeterminate, applyIndeterminate);
</script>
